import { cloneElement, JSX, PropsWithChildren } from "react";
import { IconInfoSquareRoundedFilled } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import "./info-box.scss";

type Props = {
  className?: string;
  formatting?: "for-language",
  msg: string;
  icon?: JSX.Element;
  inline?: boolean;
}

export const InfoBox = (
  {
    className,
    formatting,
    msg,
    icon = <IconInfoSquareRoundedFilled />,
    inline = false,
    children
  }: PropsWithChildren<Props>) => {

  const wrapperClasses = classNames("info-box", formatting, className, { inline });

  return (
    <div className={wrapperClasses}>
      <div className="info-box-title">
        <span className="icon">{cloneElement(icon, { className: "b-icon" })}</span>
        <span className="txt">{msg}</span>
      </div>
      {!!children &&
        <div className="info-box-content">{children}</div>
      }
    </div>);

}

export default InfoBox;
